function pauseHeroBackground(hero) {
    if (!hero) return;
    const video = hero.querySelector('.page-hero__video');
    if (video) video.pause();

    const iframe = hero.querySelector('.page-hero__embed');
    if (iframe) {
        iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
    }
}

function resumeHeroBackground(hero) {
    if (!hero) return;
    const video = hero.querySelector('.page-hero__video');
    if (video) video.play().catch(() => {});

    const iframe = hero.querySelector('.page-hero__embed');
    if (iframe) {
        iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        iframe.contentWindow?.postMessage('{"method":"play"}', '*');
    }
}

function closeHeroVideoModal(modal) {
    const embed = modal.querySelector('.page-hero__modal-video');
    if (!embed) return;

    const iframe = embed.querySelector('iframe');
    if (iframe) iframe.remove();

    const video = embed.querySelector('video');
    if (video) video.pause();

    const hero = modal.previousElementSibling;
    resumeHeroBackground(hero?.closest('.page-hero') ?? document.querySelector('.page-hero'));
}

export function initHeroModalVideo() {
    document.addEventListener('DOMContentLoaded', () => {
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-modal-open]');
            if (trigger) {
                const modalId = trigger.dataset.modalOpen;
                const modal = document.getElementById(modalId);
                if (!modal) return;

                const embed = modal.querySelector('.page-hero__modal-video[data-src]');
                if (!embed) return;

                if (!embed.querySelector('iframe')) {
                    const src = embed.dataset.src;
                    const sep = src.includes('?') ? '&' : '?';
                    const iframe = document.createElement('iframe');
                    iframe.src = src + sep + 'autoplay=1';
                    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
                    iframe.allowFullscreen = true;
                    embed.appendChild(iframe);
                }

                const hero = trigger.closest('.page-hero');
                pauseHeroBackground(hero);
                return;
            }

            const closeBtn = e.target.closest('.c-modal__close');
            const overlay = e.target.classList.contains('c-modal__overlay') ? e.target : null;
            const target = closeBtn || overlay;
            if (!target) return;

            const modal = target.closest('.c-modal');
            if (modal) closeHeroVideoModal(modal);
        });

        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') return;
            const modal = document.querySelector('.c-modal.is-modal-open');
            if (modal) closeHeroVideoModal(modal);
        });
    });
}
